// Verified public shipping policy, 20.10.2026. Server owns all stock/date decisions.
export function shippingLabel(data, total) {
  const threshold = Number(data.threshold)
  const reached = threshold > 0 && data.currency === data.rateCurrency && Number.isFinite(total) && total >= threshold
  return reached
    ? `Deine Bestellung ist versandkostenfrei nach ${data.countryName}.`
    : `Standardversand nach ${data.countryName}: ${data.rateLabel}`
}

export function acceptsVariant(pending, detail, renderedId) {
  return !detail.loading && detail.variant && String(detail.variant.id) === String(pending) && String(renderedId) === String(pending)
}

if (typeof customElements !== 'undefined') {
  class CsShippingInfo extends HTMLElement {
    connectedCallback() { this.render(Number(this.dataset.total)) }
    render(total) {
      this.dataset.total = String(total)
      const label = this.querySelector('[data-cs-shipping-label]')
      if (label) label.textContent = shippingLabel(this.dataset, total)
    }
  }
  class CsPdpDelivery extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController()
      this.pending = this.dataset.variantId
      this.syncPhysical()
      document.addEventListener(`variant:change:${this.dataset.sectionId}:${this.dataset.productId}`, event => this.onVariant(event.detail), { signal: this.abort.signal })
    }
    disconnectedCallback() { this.abort?.abort() }
    onVariant(detail) {
      const content = this.querySelector('[data-cs-variant-content]')
      if (detail.loading) this.pending = String(detail.variant?.id || '')
      if (!detail.variant || detail.loading) {
        content.querySelector('p').textContent = detail.variant ? 'Lieferstatus wird aktualisiert …' : 'Diese Kombination ist nicht verfügbar.'
        content.querySelectorAll('a').forEach(a => { a.hidden = true })
        return
      }
      // Never let a slower response for an older selection overwrite the current one.
      if (String(detail.variant.id) !== this.pending) return
      const replacement = detail.html?.getElementById(this.id)?.querySelector('[data-cs-variant-content]')
      if (replacement && acceptsVariant(this.pending, detail, replacement.dataset.variantId)) {
        content.replaceWith(replacement.cloneNode(true))
        this.syncPhysical()
      } else {
        content.querySelector('p').textContent = 'Lieferstatus derzeit nicht verfügbar. Bitte lade die Seite neu.'
      }
    }
    syncPhysical() {
      const digital = this.querySelector('[data-cs-variant-content]')?.dataset.physical === 'false'
      this.querySelector('[data-cs-physical-shipping]').hidden = digital
      this.querySelector('[data-cs-digital-shipping]').hidden = !digital
    }
  }
  if (!customElements.get('cs-shipping-info')) customElements.define('cs-shipping-info', CsShippingInfo)
  if (!customElements.get('cs-pdp-delivery')) customElements.define('cs-pdp-delivery', CsPdpDelivery)

  let timer, request, generation = 0
  const refresh = () => {
    const current = ++generation
    clearTimeout(timer)
    request?.abort()
    timer = setTimeout(async () => {
      request = new AbortController()
      try {
        const root = window.Shopify?.routes?.root || '/'
        const response = await fetch(`${root}?sections=cs-cart-delivery`, { credentials: 'same-origin', signal: request.signal })
        if (!response.ok) throw new Error('Shipping section unavailable')
        const sections = await response.json()
        if (current !== generation) return
        if (typeof sections['cs-cart-delivery'] !== 'string') throw new Error('Missing section')
        const html = new DOMParser().parseFromString(sections['cs-cart-delivery'], 'text/html')
        const next = html.querySelector('cs-cart-delivery')
        if (!next) throw new Error('Missing cart summary')
        document.querySelectorAll('cs-cart-delivery').forEach(el => {
          el.innerHTML = next.innerHTML
          el.hidden = next.hidden
          el.dataset.total = next.dataset.total
          el.dataset.count = next.dataset.count
        })
        document.querySelectorAll('cs-shipping-info').forEach(el => el.render?.(Number(next.dataset.total)))
      } catch (error) {
        if (error.name === 'AbortError' || current !== generation) return
        // Avoid keeping a stale promise of free shipping after a failed cart refresh.
        document.querySelectorAll('cs-shipping-info [data-cs-shipping-label]').forEach(el => { el.textContent = 'Versandkosten werden an der Kasse bestätigt.' })
        document.querySelectorAll('cs-cart-delivery').forEach(el => {
          el.innerHTML = '<p>Versandkosten und Lieferinformationen werden an der Kasse bestätigt.</p>'
        })
      }
    }, 100)
  }
  for (const event of ['cart:updated', 'ajaxProduct:added', 'cart:build', 'product-form:submit:success']) document.addEventListener(event, refresh)
}
